import React, {useState} from 'react'
import {Field, FieldArray} from 'redux-form'
import { I18n } from 'react-i18next'
import {getGroupModel, getModule, getUserIdAndName, getEdit} from '../../selectors'
import {connect} from 'react-redux'
import Conversation2 from "../../../../components/Conversation/conversation2";
import getFormValidations from "./formValidations";

const arrayToObject = (array= []) =>
    array.reduce((obj, item) => {
        obj[item.id] = item
        return obj
    }, {})

const VisualComponent = ({
                             initialMessages,
                             fields: { push, remove, insert, getAll },
                             path,
                             editable,
                             disabled,
                             placeholder,
                             module,
                             user,
                             t,
                             language,
                             groupModel,
                             accessId
                         }) => {
    const objects = getAll() || [];
    const allIds = objects && objects.map(o => o.id)
    const byId = arrayToObject(objects)

    // Function to update a comment by ID
    const updateMessage = (id, updates, propertiesToDelete = []) => {
        const index = objects.findIndex(obj => obj.id === id)
        if (index !== -1) {
            // Get the current object and merge with updates
            const updatedObject = { ...objects[index], ...updates }

            // Remove specified properties
            propertiesToDelete.forEach(prop => {
                delete updatedObject[prop]
            })

            // Remove the old one and insert the updated one at the same position
            remove(index)
            insert(index, updatedObject)
        }
    }

    // Function to remove a comment by ID
    const removeMessage = (id) => {
        const index = objects.findIndex(obj => obj.id === id)
        if (index !== -1) {
            remove(index)
        }
    }

    return (
        <I18n ns={[module.model, 'platform']}>
            {t => (
                <Conversation2
                    objects={objects}
                    initialObjects={initialMessages}
                    allIds={allIds}
                    byId={byId}
                    url="file"
                    currentUser={user}
                    placeholder={placeholder}
                    t={t}
                    push={push}
                    update={updateMessage}
                    remove={remove}
                    removeById={removeMessage}
                    language={language}
                    groupModel={groupModel}
                    accessId={accessId}
                    disabled={disabled}
                    editable={editable}
                    path={path}
                />
            )}
        </I18n>
    )
}

const ConversationField = ({ field, module, user, objectMode, t, language, groupModel, accessId, initialValues, editObjectValues }) => {
    const validations = getFormValidations(field)

    const initialMessages = initialValues[field.path] || []

    return (
        <FieldArray
            name={field.path}
            path={field.tKey || field.path}
            placeholder={field.placeholder}
            component={VisualComponent}
            validate={validations}
            disabled={field.disabled || !field.writable}
            editable={!field.editable ? objectMode === 'newObject' : field.editable}
            module={module}
            user={user}
            rerenderOnEveryChange={true}
            t={t}
            language={language}
            groupModel={groupModel}
            accessId={accessId}
            initialMessages={initialMessages}
        />
    )
}

const mapStateToProps = (state) => ({
    groupModel: getGroupModel(state),
    accessId: getEdit(state).accessId,
    module: getModule(state),
    user: getUserIdAndName(state),
})

export default connect(mapStateToProps)(ConversationField)